import React, { useEffect, useState } from "react";
import "./style.css";
import { CreateTeacher, EditTeacher, ShowQueries } from "./Modals";
import api from "../../utilis/api";
import { toast } from "react-toastify";
import { url } from "../../utilis/contant";

const Queries = () => {
  const [contact, setContact] = useState([]);
  const [modalTeacher, setModalTeacher] = useState(null);
  const [search, setSearch] = useState("");

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const getTeachers = async () => {
    try {
      const response = await api.get("/contact/admin");
      console.log(response);
      setContact(response.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  useEffect(() => {
    getTeachers();
  }, [isEditModalOpen]);
  const handleActive = async (id, status) => {
    try {
      const res = await api.put(
        `/user/${id}`,
        {
          accountverified: !status,
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (res) {
        toast.success("Teacher Updated Successfully");
        getTeachers();
      }
    } catch (error) {
      toast.error("Status Not Updated");
    }
  };
  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/user/${id}`, {
        headers: { "Content-Type": "application/json" },
      });

      if (res) {
        toast.success("Teacher Deleted Successfully");
        getTeachers();
      }
    } catch (error) {
      toast.error("Teacher Not Deleted");
    }
  };
  const filteredteachers = contact?.filter((s) =>
    `${s.name} ${s.email} ${s.phone}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );
  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    return names
      .map((n) => n[0]?.toUpperCase())
      .join("")
      .slice(0, 2); // Max 2 letters
  };
  console.log(contact);
  console.log(filteredteachers);
  return (
    <div className="overview-container">
      <header className="overview-header ">
        <div className="header-text bg-black">
          <span className=" header-subtitle">Welcome Back, Robert</span>
          <h1 className="header-title">Users Quiries</h1>
        </div>
        {/* */}
        {/* <button className="add-btn" onClick={() => setIsCreateModalOpen(true)}>
          New Teacher
        </button> */}
      </header>
      {/* SEARCH BAR */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by name, email..."
          value={search}
          disabled={isEditModalOpen}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Message</th>
              {/* <th>Status</th> */}
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredteachers?.length > 0 ? (
              filteredteachers?.map((teacher) => (
                <tr key={teacher._id}>
                  <td>{teacher.name}</td>
                  <td>{teacher.email}</td>
                  <td>
                    {teacher.message.split(" ").slice(0, 10).join(" ")}
                    {teacher.message.split(" ").length > 10 ? "..." : ""}
                  </td>
                  {/* <td>{teacher.status}</td> */}
                  {/* ACTIONS */}
                  <td>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        setIsEditModalOpen(true);
                        setModalTeacher(teacher);
                      }}
                    >
                      View
                    </button>
                    {/* <button
                      className="delete-btn"
                      onClick={() => handleDelete(teacher._id)}
                    >
                      Delete
                    </button> */}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-data">
                  No Queries found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isEditModalOpen && (
        <ShowQueries
          onClose={() => setIsEditModalOpen(false)}
          queries={modalTeacher}
        />
      )}
    </div>
  );
};
export default Queries;
